import { SBRMFormActionProps, useSBRMForm } from '@supplement-bacon/sbrm-react'
import MetadataKey from '@utils/MetadataKey'
import { Alert, Col, Form, Input, Row, Space } from 'antd'
import { useCallback, useEffect } from 'react'
import SBPhoneInput from '../../../../modules/sb-antd-phone-input/SBPhoneInput'
import { emailRule, isE164Phone, requiredRule } from '../../../../utils/rules'

const Create = ({ form, formProps }: SBRMFormActionProps) => {
  const { metadata, getMetadata } = useSBRMForm()

  const companyId = useCallback(() => {
    return getMetadata(MetadataKey.CompanyId)
  }, [metadata, getMetadata])

  useEffect(() => {
    if (companyId() === undefined) {
      form.setFieldsValue({
        company: companyId(),
      })
    }
  }, [companyId()])
  return (
    <Form {...formProps} form={form} layout="vertical">
      <Form.Item
        name="company"
        hidden
        style={{ display: 'none' }}
        initialValue={companyId()}
      >
        <Input type="hidden" />
      </Form.Item>
      <Space
        style={{ display: 'flex', marginBottom: 8 }}
        orientation="vertical"
      >
        <Row gutter={[16, 16]}>
          <Col span={12}>
            <Form.Item
              name={'firstName'}
              rules={[requiredRule()]}
              label="First Name"
            >
              <Input placeholder="Contact First Name" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name={'lastName'}
              rules={[requiredRule()]}
              label="Last Name"
            >
              <Input placeholder="Contact Last Name" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col span={12}>
            <Form.Item
              name={'email'}
              rules={[requiredRule(), emailRule()]}
              label="Email"
            >
              <Input
                className="authField"
                placeholder={'Contact Email'}
                autoComplete="email"
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name={'phone'} rules={[isE164Phone()]} label="Phone">
              <SBPhoneInput
                enableSearch
                disableParentheses
                placeholder="Contact Phone"
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col span={12}>
            <Form.Item
              name={'position'}
              rules={[requiredRule()]}
              label="Position"
            >
              <Input placeholder="Contact Position" />
            </Form.Item>
          </Col>
        </Row>
      </Space>
      <Alert
        title="Company contact invitation"
        description="An email will be sent to this contact to join the company back office. They will then be able to manage the company, add employees, and monitor their expenses."
        type="info"
        showIcon
      />
    </Form>
  )
}

export default Create
